// Mock Firebase using localStorage
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";


const firebaseConfig = {
  apiKey: "AIzaSyB8j6kgFV51YCKAl_8Ia8rV01QvJxK0E68",
  authDomain: "bytesplash-db.firebaseapp.com",
  databaseURL: "https://bytesplash-db-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "bytesplash-db",
  storageBucket: "bytesplash-db.firebasestorage.app",
  messagingSenderId: "759832240114",
  appId: "1:759832240114:web:cf02b92fd599156f86d56b",
  measurementId: "G-YW7HG9LWJ1"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);

// LocalStorage helper functions
export const localStorageDb = {
  // Initialize with sample data if not present
  initializeData: () => {
    if (!localStorage.getItem('courses')) {
      localStorage.setItem('courses', JSON.stringify(sampleCourses));
    }
    if (!localStorage.getItem('modules')) {
      localStorage.setItem('modules', JSON.stringify(sampleModules));
    }
    if (!localStorage.getItem('batches')) {
      localStorage.setItem('batches', JSON.stringify(sampleBatches));
    }
  },
  
  // Get all items from a collection
  getCollection: (collection) => {
    const data = localStorage.getItem(collection);
    return data ? JSON.parse(data) : [];
  },
  
  // Get a specific item by ID
  getDocument: (collection, id) => {
    const items = localStorageDb.getCollection(collection);
    return items.find(item => item.id === id) || null;
  },
  
  // Add a new item to a collection
  addDocument: (collection, data) => {
    const items = localStorageDb.getCollection(collection);
    const newItem = { ...data, id: data.id || crypto.randomUUID() };
    items.push(newItem);
    localStorage.setItem(collection, JSON.stringify(items));
    return newItem;
  },
  
  // Update an existing item
  updateDocument: (collection, id, data) => {
    const items = localStorageDb.getCollection(collection);
    const index = items.findIndex(item => item.id === id);
    
    if (index !== -1) {
      items[index] = { ...items[index], ...data };
      localStorage.setItem(collection, JSON.stringify(items));
      return true;
    }
    return false;
  },
  
  // Delete an item
  deleteDocument: (collection, id) => {
    const items = localStorageDb.getCollection(collection);
    const filteredItems = items.filter(item => item.id !== id);
    
    if (filteredItems.length !== items.length) {
      localStorage.setItem(collection, JSON.stringify(filteredItems));
      return true;
    }
    return false;
  },
  
  // Query items (simple filtering)
  queryCollection: (collection, field, value) => {
    const items = localStorageDb.getCollection(collection);
    return items.filter(item => item[field] === value);
  }
};

// Sample course data to initialize localStorage
const sampleCourses = [
  {
    id: '1',
    title: 'Python Full Stack Developer',
    description: 'Learn to build complete web applications with Python, from backend to frontend.',
    category: 'programming',
    duration: '120',
    level: 'intermediate',
    price: 79.99,
    status: 'active',
    thumbnailUrl: 'https://via.placeholder.com/400x250/0071bd/FFFFFF?text=Python+Full+Stack',
    introVideoUrl: 'https://www.youtube.com/watch?v=sample-video-1',
    instructor: 'John Smith',
    students: 145,
    rating: 4.7,
    subjects: [
      { subjectId: '1', subjectName: 'HTML & HTML5', moduleIds: ['1', '2', '3'] },
      { subjectId: '2', subjectName: 'CSS Fundamentals', moduleIds: ['4', '5'] },
      { subjectId: '3', subjectName: 'JavaScript Basics', moduleIds: ['6', '7', '8'] },
      { subjectId: '4', subjectName: 'React Basics', moduleIds: ['9', '10'] },
      { subjectId: '5', subjectName: 'Node.js', moduleIds: ['11', '12'] }
    ]
  },
  {
    id: '2',
    title: 'MERN Stack Development',
    description: 'Master MongoDB, Express.js, React, and Node.js to build full-stack JavaScript applications.',
    category: 'programming',
    duration: '90',
    level: 'advanced',
    price: 89.99,
    status: 'active',
    thumbnailUrl: '/lovable-uploads/a1da022b-e1e0-441c-bac9-1854ca7b2a2e.png',
    instructor: 'Ajay Prammasani',
    students: 30,
    rating: 4.2
  },
  {
    id: '3',
    title: 'ReactJs Web Development',
    description: 'Learn modern React.js to build interactive web applications with professional techniques.',
    category: 'web development',
    duration: '72',
    level: 'advanced',
    price: 69.99,
    status: 'active',
    thumbnailUrl: '/lovable-uploads/bd1da799-69c6-4ffe-b4c6-5e010b976c90.png',
    instructor: 'Ajay Prammasani',
    students: 120,
    rating: 4.8
  },
  {
    id: '4',
    title: 'Dotnet Backend Development',
    description: 'Learn to build scalable backends using .NET Core, Entity Framework, and Azure services.',
    category: 'application development',
    duration: '85',
    level: 'advanced',
    price: 79.99,
    status: 'active',
    thumbnailUrl: '/lovable-uploads/8c086453-46c1-4dc2-a73e-1d244a0c2d90.png',
    instructor: 'Sagar Reddy Guvvala',
    students: 41,
    rating: 4.9
  }
];

// Sample modules data
const sampleModules = [
  {
    id: '1',
    moduleName: 'HTML Introduction to Web Development',
    moduleDescription: 'Learn the fundamentals of HTML to structure web pages.',
    courseId: '1',
    isEnabled: true,
    batches: [
      { batchId: '1', isCompleted: true },
      { batchId: '2', isCompleted: true },
      { batchId: '3', isCompleted: true },
      { batchId: '4', isCompleted: true },
      { batchId: '5', isCompleted: true }
    ],
    moduleTopics: [
      {
        topicHeading: 'HTML Introduction',
        topics: [
          'Introduction to HTML',
          'Getting Started with HTML',
          'Advanced HTML Concepts',
          'Best Practices in HTML'
        ]
      }
    ],
    recordings: [
      { batchId: '1', video: 'https://youtu.be/oMZNw' },
      { batchId: '3', video: 'https://youtu.be/8Y-ziEr' }
    ],
    materials: [
      { link: '../assets/pdfs/HTML basics.pdf' }
    ]
  },
  {
    id: '2',
    moduleName: 'HTML Forms and Input Types',
    moduleDescription: 'Create forms and understand different input types in HTML.',
    courseId: '1',
    isEnabled: true,
    batches: [
      { batchId: '1', isCompleted: true },
      { batchId: '2', isCompleted: false }
    ],
    moduleTopics: [
      {
        topicHeading: 'HTML Forms',
        topics: [
          'Basic Form Structure',
          'Form Inputs and Elements',
          'Form Validation'
        ]
      }
    ],
    recordings: [
      { batchId: '1', video: 'https://youtu.be/forms-intro' }
    ],
    materials: [
      { link: '../assets/pdfs/HTML forms.pdf' }
    ]
  },
  {
    id: 'nynarrdFSFBoj9lNLLGt',
    moduleName: 'SQL Basics',
    moduleDescription: 'Learn the fundamentals of SQL database querying.',
    courseId: '4',
    isEnabled: true,
    batches: [],
    moduleTopics: [
      {
        topicHeading: 'Database Basics',
        topics: [
          'Introduction to Databases',
          'SQL Query Structure',
          'SELECT, INSERT, UPDATE, DELETE'
        ]
      }
    ],
    recordings: [],
    materials: []
  },
  {
    id: '60fS0Pp8ercwEWa0IRVL',
    moduleName: 'Advanced SQL',
    moduleDescription: 'Master complex SQL queries and database optimization.',
    courseId: '4',
    isEnabled: true,
    batches: [],
    moduleTopics: [
      {
        topicHeading: 'Advanced Database Operations',
        topics: [
          'Joins and Relationships',
          'Subqueries',
          'Performance Optimization'
        ]
      }
    ],
    recordings: [],
    materials: []
  },
  {
    id: 'gHnvOcBmjj4KX2VhN3WO',
    moduleName: 'Java Fundamentals',
    moduleDescription: 'Introduction to Java programming language.',
    courseId: '4',
    isEnabled: true,
    batches: [],
    moduleTopics: [
      {
        topicHeading: 'Java Basics',
        topics: [
          'Variables and Data Types',
          'Control Flow',
          'Object-Oriented Programming'
        ]
      }
    ],
    recordings: [],
    materials: []
  },
  {
    id: 'R1hgPzOKALzpT1fsyHB9',
    moduleName: 'Spring Boot Basics',
    moduleDescription: 'Getting started with Spring Boot framework.',
    courseId: '4',
    isEnabled: true,
    batches: [],
    moduleTopics: [
      {
        topicHeading: 'Spring Boot Introduction',
        topics: [
          'Spring Boot Architecture',
          'Dependency Injection',
          'Creating REST APIs'
        ]
      }
    ],
    recordings: [],
    materials: []
  }
];

// Sample batches data
const sampleBatches = [
  { id: '1', batchName: 'JFS - 8', courseId: '1', description: 'Java Full Stack Batch 8', startDate: '2023-01-15', endDate: '2023-04-15', isActive: true, status: 'active', students: [] },
  { id: '2', batchName: 'PFS - 8', courseId: '1', description: 'Python Full Stack Batch 8', startDate: '2023-02-10', endDate: '2023-05-10', isActive: true, status: 'active', students: [] },
  { id: '3', batchName: 'PFS - 11', courseId: '1', description: 'Python Full Stack Batch 11', startDate: '2023-03-05', endDate: '2023-06-05', isActive: true, status: 'active', students: [] },
  { id: '4', batchName: 'PFS - 12', courseId: '1', description: 'Python Full Stack Batch 12', startDate: '2023-04-01', endDate: '2023-07-01', isActive: true, status: 'active', students: [] },
  { id: '5', batchName: 'CSR Batch', courseId: '1', description: 'Customer Support Training', startDate: '2023-03-15', endDate: '2023-04-15', isActive: false, status: 'completed', students: [] }
];

// Initialize sample data
localStorageDb.initializeData();
